import { SearchState } from '@reducers/search';
import { AdTypes, CategoryID } from '@sbt-web/network/types';
import { GeoLevel, getGeoLevel } from '@sbt-web/networking';
import { Category } from '@sbt-web/category-utils';
import { adTypesShortLabelsMap } from '@shared/tools/search/values';
import { getVehiclesLabel } from '../../helpers/automotive';
import { capitalizeFirst, formatWithSpaces } from '../../helpers/common';
import { getGeoLabel, SEOTag } from '../../helpers/geo';
import { descriptionCustomStrings } from './customStrings';

function getCategoryLabel(category: Category): string {
  if (category.id !== CategoryID.Tutte) {
    let categoryLabel = category.label;
    switch (category.id) {
      case CategoryID.AudioVideo: {
        categoryLabel = 'Audio e video';
        break;
      }
      case CategoryID.CamerePostiLetto: {
        categoryLabel = 'camere e posti letto';
        break;
      }
      case CategoryID.LoftMansarde: {
        categoryLabel = 'loft e mansarde';
        break;
      }
      case CategoryID.UfficiLocali: {
        categoryLabel = 'uffici locali commerciali';
        break;
      }
      case CategoryID.Attrezzature: {
        categoryLabel = 'attrezzature';
        break;
      }
      case CategoryID.ConsoleVideogiochi: {
        categoryLabel = 'videogiochi';
        break;
      }
      case CategoryID.CasaPersona: {
        categoryLabel = 'Per la casa e per la persona';
        break;
      }
      case CategoryID.SportsHobby: {
        categoryLabel = 'Sport e hobby';
        break;
      }
      case CategoryID.AltriAnnunci:
      case CategoryID.Altri:
        categoryLabel = 'Viaggi, accessori e oggetti';
    }

    return categoryLabel.toLowerCase();
  }
  return 'auto, case e oggetti vari nuovi e usati';
}

export function getMetaDescription(search: SearchState): string {
  const geoLevel = getGeoLevel(search.geo, search.searchNearRegions);
  const categoryLabel = getCategoryLabel(search.category);
  const geoLabel = getGeoLabel(search, geoLevel, SEOTag.META_DESCRIPTION);

  let descriptionCustomString = descriptionCustomStrings[search.category.id];
  let dealTypeVacation = '';
  if (
    search.category.id == CategoryID.Tutte &&
    search.adType &&
    search.adType == AdTypes.VacationRent
  ) {
    descriptionCustomString = 'case, appartamenti e B&B';
    dealTypeVacation = ' per vacanze';
  }

  let adTypeLabel = `in ${adTypesShortLabelsMap[search.adType].toLowerCase()}`;
  if (
    search.category.id == CategoryID.LavoroServizi ||
    search.category.id == CategoryID.OfferteLavoro ||
    search.category.id == CategoryID.Candidati
  ) {
    adTypeLabel = '';
  }

  const descriptionChunks: string[] = [];
  const commonSuffixPart1 = 'scopri subito migliaia di';
  const commonSuffixPart2 = 'su Subito.it';
  if (search.query) {
    // Query
    descriptionChunks.push(capitalizeFirst(search.query));
    if (search.category.id !== CategoryID.Tutte) {
      descriptionChunks.push(adTypeLabel, 'in', `${categoryLabel + geoLabel}:`);
    } else {
      descriptionChunks.push(`${adTypeLabel + geoLabel}:`);
    }
    descriptionChunks.push(
      commonSuffixPart1,
      'annunci di privati e aziende e trova quello che cerchi',
      commonSuffixPart2
    );
  } else {
    // Without Query
    const genericPrefix = 'Scopri subito migliaia di annunci di';
    const regionLabel = geoLevel !== GeoLevel.Italia ? geoLabel : '';

    const vehiclesLabel = getVehiclesLabel(search, '');
    if (
      (search.category.id == CategoryID.Auto ||
        search.category.id == CategoryID.Moto) &&
      vehiclesLabel
    ) {
      const automotiveCategory =
        search.category.id == CategoryID.Moto ? 'moto' : 'auto';

      descriptionChunks.push(
        `${vehiclesLabel + geoLabel}:`,
        `scopri subito migliaia di annunci di privati e di concessionarie e trova oggi la tua ${automotiveCategory} usata su Subito.it`
      );
    } else {
      descriptionChunks.push(
        search.category.id !== CategoryID.Tutte ? 'Annunci di' : genericPrefix
      );

      if (search.category.id === CategoryID.Tutte) {
        descriptionChunks.push(descriptionCustomString);

        if (regionLabel === '') {
          descriptionChunks.push(`${adTypeLabel + dealTypeVacation}.`);
        } else {
          descriptionChunks.push(
            !adTypeLabel ? regionLabel : `${adTypeLabel + regionLabel}:`
          );
        }
      } else {
        let tmpChunk = categoryLabel;
        tmpChunk += adTypeLabel ? ` ${adTypeLabel}` : '';
        tmpChunk += `${regionLabel}:`;

        descriptionChunks.push(tmpChunk);
      }

      descriptionChunks.push(
        search.category.id === CategoryID.Tutte
          ? 'Trova oggi stesso quello che cerchi'
          : `${commonSuffixPart1} ${descriptionCustomString}`,
        commonSuffixPart2
      );
    }
  }

  // Add Pagination
  if (search.page && search.page > 1) {
    descriptionChunks.push('-', search.page.toString());
  }

  return formatWithSpaces(...descriptionChunks);
}
